import { StorageLocationType } from "./schema/storage-location.js";

/**
 * Returns true if WMS Source of Truth is enabled for the given location.
 * - If `sourceOfTruthEnabled` is false, returns false for all locations.
 * - If `sourceOfTruthLocationIds` is empty/undefined, returns true for all locations (backwards compatible).
 * - Otherwise, returns true only if the location is in the list.
 */
export function isWmsSotEnabledForLocation(
  wms:
    | {
        sourceOfTruthEnabled?: boolean | null;
        sourceOfTruthLocationIds?: string[] | null;
      }
    | null
    | undefined,
  locationId: string | null | undefined,
): boolean {
  if (!wms?.sourceOfTruthEnabled) {
    return false;
  }
  const locationIds = wms.sourceOfTruthLocationIds;
  if (!locationIds?.length) {
    return true;
  }
  if (!locationId) {
    return false;
  }
  return locationIds.includes(locationId);
}

export function isExactInventoryItemAssignmentEnabled(
  wms:
    | { pickSession?: { exactInventoryItemAssignment?: boolean | null } | null }
    | null
    | undefined,
): boolean {
  return wms?.pickSession?.exactInventoryItemAssignment === true;
}

export enum TransferDistributionMode {
  BIN_FIRST = "bin-first",
  ITEM_FIRST = "item-first",
}

export enum SameBinSortMode {
  SKU = "sku",
  ORDER_DATE = "order-date",
}

/**
 * Mode of zone-based picking for a team.
 *
 * - NONE: zone picking disabled — pick wave generation runs without any
 *   zone awareness, exactly as before the feature was introduced.
 * - SEQUENTIAL: single tote per multi-item order is handed off between
 *   zones in `zoneSequence` order. Each FG starts at its earliest-zone
 *   wave; pickers at later zones receive continuation totes from a
 *   separate flow. This is the v1 mode.
 * - (future) SIMULTANEOUS: multiple pickers work the same FG's items
 *   concurrently across zones, recombining at pack. Not yet implemented.
 */
export enum ZonePickingMode {
  NONE = "none",
  SEQUENTIAL = "sequential",
}

export const DEFAULT_BIN_COUNT_THRESHOLD_DAYS = 30;

export const TRANSFER_EXCLUDED_BIN_TYPES: readonly StorageLocationType[] = [
  StorageLocationType.EXTERNAL,
  StorageLocationType.LOST,
  StorageLocationType.TRANSIT,
  StorageLocationType.UNMAPPED,
  StorageLocationType.DEFAULT,
];
